import React from 'react';
import { VStack , Box , Text, Switch } from '@chakra-ui/react';
import { useRemoveMfaMutation } from 'reducers/auth.service';
export default function RemoveMFA({ id ,mfaValue, data , isFetching = false, refetch }) {
    const [removeMfa] = useRemoveMfaMutation();

    const handleMfa = ()=>{
        removeMfa({ id, USERTYPE: data?.userType }).unwrap().then(()=>{
            refetch();
        });
    };

    return (
        <VStack align="start" spacing={8}>
            <Box display="flex" justifyContent="space-between" w="full">
                <Text fontWeight="bold">MULTI-FACTOR AUTHENTICATION</Text>
                <Switch disabled={ !mfaValue || isFetching} isChecked={mfaValue} onChange={handleMfa} />
            </Box>
            {
                !mfaValue && <Box>
                    <p>
                                You don&apos;t have access to enable the MFA for the user.
                    </p>
                </Box>
            }
        </VStack>

    );
}
